import { BaseApiService } from '@/shared/api/BaseApiService';

export interface Clinic {
  id: string;
  organizationId: string;
  displayName: string;
  status: string;
  defaultCountryId: string | null;
  defaultStateId: string | null;
  defaultDistrictId: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  gstNumber: string | null;
  registrationNumber: string | null;
  addressId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ClinicsListResult {
  items: Clinic[];
  nextCursor?: string;
}

export interface CreateClinicInput {
  displayName: string;
  defaultCountryId?: string;
  defaultStateId?: string;
  defaultDistrictId?: string | null;
}

export interface UpdateClinicInput {
  displayName?: string;
  defaultCountryId?: string | null;
  defaultStateId?: string | null;
  defaultDistrictId?: string | null;
  phone?: string | null;
  email?: string | null;
  website?: string | null;
  gstNumber?: string | null;
  registrationNumber?: string | null;
  address?: {
    countryId: string;
    stateId: string;
    districtId: string | null;
    line1: string;
    line2?: string | null;
    cityTown: string;
    pincode: string;
  };
}

export class ClinicsService extends BaseApiService {
  protected readonly resourcePath = 'clinics';

  async list(): Promise<ClinicsListResult> {
    return this.get('');
  }

  async getById(id: string): Promise<Clinic> {
    return this.get(`/${id}`);
  }

  async create(input: CreateClinicInput): Promise<Clinic> {
    return this.post('', input);
  }

  async update(id: string, input: UpdateClinicInput): Promise<Clinic> {
    return this.put(`/${id}`, input);
  }

  async deactivate(id: string): Promise<{ success: boolean }> {
    return this.delete(`/${id}`);
  }
}
